import moment from 'moment'

// 文本标记
const strMark = function(str, maskWord) {
  let newStr = str
  // if (newStr.includes(maskWord)) {
  if (newStr && maskWord && newStr.toLowerCase().includes(maskWord.toLowerCase())) {
    const index = newStr.toLowerCase().indexOf(maskWord.toLowerCase())
    const newword = newStr.slice(index, index + maskWord.length)
    var reg = new RegExp(maskWord, 'gi')
    newStr = newStr.replace(reg, `<span class="text-sign">${newword}</span>`)
  }
  return newStr
}
// 部门遍历
const departmentCycle = function(department, id) {
  const dId = parseInt(id)
  let result = ''
  department.forEach(v => {
    if (dId === parseInt(v.value)) {
      result = v.label
      return false
    } else {
      if (v.child && result === '') {
        result = departmentCycle(v.child, dId)
      } else {
        return false
      }
    }
  })
  return result
}
// 每天6.00  12.30  18.00 禁止刷新
const isAllowRefresh = () => {
  const date = new Date()
  const nowDay = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
  const moring = moment().isBetween(`${nowDay} 06:00`, `${nowDay} 06:10`, 'miniue')
  const noon = moment().isBetween(`${nowDay} 12:30`, `${nowDay} 12:40`, 'miniue')
  const night = moment().isBetween(`${nowDay} 18:00`, `${nowDay} 18:10`, 'miniue')
  return moring || noon || night
}

export { strMark, departmentCycle, isAllowRefresh }
